<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (tap)="cancel()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-searchbar [(ngModel)]="queryText" placeholder="Search Plant"></ion-searchbar>
    </ion-toolbar>
</ion-header>

<ion-content>

    <ion-refresher slot="fixed" (ionRefresh)="updateDetailLines($event)">
        <ion-refresher-content
                pullingIcon="arrow-dropdown"
                pullingText="Pull to refresh"
                refreshingSpinner="circles"
                refreshingText="Fetching Detail Lines...">
        </ion-refresher-content>
    </ion-refresher>

    <!--    [name]="dtLine.isChecked ? 'checkmark' : 'close'"-->
    <!--    [color]="dtLine.isChecked ? 'success' : 'danger'"-->
    <ion-virtual-scroll [items]="detailLinesList | filterDetailLine: queryText" class="ion-no-padding  ion-no-margin">
        <ion-item *virtualItem="let dtLine" lines="none" class="ion-no-padding  ion-no-margin">
            <ion-grid class="ion-no-padding  ion-no-margin">
                <ion-row class="ion-no-padding  ion-no-margin"
                         (click)="selectLine(dtLine); markAccessories(dtLine.isChecked, dtLine.line)">
                    <!--            <ion-col size="1" class="ion-align-self-center ion-text-center">-->
                    <!--                <ion-button color="none" size="small">-->
                    <!--                    <ion-icon slot="icon-only"></ion-icon>-->
                    <!--                </ion-button>-->
                    <!--            </ion-col>-->
                    <ion-col size="11" class="ion-no-padding"
                             [ngStyle]="dtLine.isChecked ? {'background-color': darkColor} : {'background-color': lightColor}">
                        <ion-item lines="none" class="ion-no-padding"
                                  [ngStyle]="dtLine.isChecked ? {'background-color': darkColor} : {'background-color': lightColor}">
                            <ion-label
                                    [ngStyle]="dtLine.isChecked ? {'background-color': darkColor} : {'background-color': lightColor}"
                                    class="ion-padding ion-no-margin">
                                <p>{{ dtLine.line.pdesc }} {{ dtLine.line.reg ? dtLine.line.reg : '' }}
                                    <span *ngIf="dtLine.line.typ === 'P'" style="color: red">PACKAGE</span>
                                    <span *ngIf="dtLine.line.packageName && dtLine.line.packageSeq && dtLine.line.typ === 'S'"
                                          style="color: red">PLUS ACCESSORIES</span>
                                </p>
                                <h2 style="color: deepskyblue">{{ dtLine.line.description }}</h2>
                            </ion-label>
                            <!--                    <ion-input type="number" (ionChange)="checkQty($event, dtLine)" [(ngModel)]="dtLine.line.qty"-->
                            <!--                               *ngIf="dtLine.line.typ !== 'S'"-->
                            <!--                               placeholder="Set Quantity" class="ion-text-end"></ion-input>-->
                        </ion-item>
                        <ion-item (click)="selectLine(dtLine)" *ngIf="dtLine.line.plu">
                            <ion-label>
                                <p>Consumable</p>
                                <h2 style="color: deepskyblue">{{ dtLine.line.comment ? dtLine.line.comment : dtLine.line.description}}</h2>
                            </ion-label>
                        </ion-item>
                        <ion-item
                                *ngIf="dtLine.line.reg && !(dtLine.line.typ === 'P') && mobileConfig && mobileConfig.mobilehireHealthCareInUse !== 1"
                                class="ion-align-self-baseline ion-no-padding" lines="none">
                            <ion-label class="ion-text-wrap ion-padding  ion-no-margin"
                                       [ngStyle]="dtLine.isChecked ? {'background-color': darkColor} : {'background-color': lightColor}">
                                Fuel:
                            </ion-label>
                            <ion-select interface="popover" [(ngModel)]="dtLine.line.fuelLevel"  class="ion-text-wrap ion-padding  ion-no-margin"
                                        [ngStyle]="dtLine.isChecked ? {'background-color': darkColor} : {'background-color': lightColor}"
                                        placeholder="Select Level"
                                        [disabled]="document.documentType !== docTypes.RETURN && dtLine.line.status === 9"
                                        [compareWith]="compareFuelLevel"
                                        (ionChange)="fuelSelectChanged(dtLine); markAccessories(dtLine.isChecked, dtLine.line)">
                                <ion-select-option *ngFor="let fValue of fuelValues"
                                                   [value]="fValue">{{fValue.shortDescription}}</ion-select-option>
                            </ion-select>
                        </ion-item>
                        <!--                <ion-item *ngIf="dtLine.line.typ === 'M'" lines="none">-->
                        <!--                    <ion-label>Quantity:</ion-label>-->
                        <!--                    <ion-input type="number" (ionChange)="checkQty($event, dtLine)" [(ngModel)]="dtLine.line.qty"-->
                        <!--                               placeholder="Set Quantity" class="ion-text-end" clearInput></ion-input>-->
                        <!--                </ion-item>-->
                        <ion-list>
                            <ion-item *ngFor="let packageLine of packageLinesList | filterPackageSeq: dtLine.line">
                                <ion-label
                                        *ngIf="packageLine.line.typ === 'M'">{{packageLine.line.description}}</ion-label>
                                <ion-label *ngIf="packageLine.line.typ === 'S'">
                                    <p>{{packageLine.line.description}}</p>
                                    <p>{{packageLine.line.reg}}</p>
                                </ion-label>
                                <ion-checkbox *ngIf="packageLine.line.typ === 'S'" slot="end"
                                              (ionChange)="dtLine.isChecked = true" [(ngModel)]="packageLine.isChecked"
                                              color="success"></ion-checkbox>
                                <!--                        <ion-input *ngIf="packageLine.line.typ === 'M'" class="ion-text-end" type="number"-->
                                <!--                                   (ionChange)="dtLine.isChecked = true" [(ngModel)]="packageLine.line.qty"></ion-input>-->
                            </ion-item>
                        </ion-list>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-item>
    </ion-virtual-scroll>
    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button (tap)="addDetailLines()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>

<ion-footer class="ion-text-center">
    <p color="medium">Pull the screen to refresh</p>
</ion-footer>
